import React from 'react';
import {Button, InfoMedia, List, SecSubTitle, SecTitle} from '../../components';

const AboutSevenCopy = ({title, subTitle, description, imgPath, bottomList, flip = false, index}) => (
    <div className="background-image" style={{backgroundImage: !flip ? 'url(images/bg/about-bg-5-1.jpg)' : ''}}>
        <div className="container container-style1">
            <div className="row flex-row-reverse align-items-center gx-70 AboutSevenCopyMedia-min-lg">
                {index % 2 === 1 ? (
                    <div className={'flex-row-reverse d-flex flex-wrap'}>
                        <div className="col-12 col-lg-6">
                            <div className="about-box2">
                                <SecSubTitle><i className="fas fa-bring-forward"/>{subTitle}</SecSubTitle>
                                <SecTitle className="text-capitalize">{title}</SecTitle>
                                <p>{description}</p>
                                <List className="list-style11">
                                    {bottomList.map(o => <List.Item><i className="far fa-check-circle"/> {o}
                                    </List.Item>)}
                                </List>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 px-4">
                            <img style={{height: '100%', objectFit: 'cover'}} className={'about-box2'} src={imgPath}
                                 alt="aboutthumb"/>
                        </div>
                    </div>
                ) : (<div className={'flex-row-reverse d-flex flex-wrap'}>

                    <div className="col-12 col-lg-6 px-4">
                        <img style={{height: '100%', objectFit: 'cover'}} className={'about-box2'} src={imgPath}
                             alt="aboutthumb"/>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="about-box2">
                            <SecSubTitle><i className="fas fa-bring-forward"/>{subTitle}</SecSubTitle>
                            <SecTitle className="text-capitalize h1">{title}</SecTitle>
                            <p>{description}</p>
                            <List className="list-style11">
                                {bottomList.map(o => <List.Item><i className="far fa-check-circle"/> {o}</List.Item>)}
                            </List>
                        </div>
                    </div>
                </div>)}
            </div>


            {/*<div className="row flex-row-reverse align-items-center gx-70 ">*/}
                <div className={'AboutSevenCopyMedia-max-lg'}>
                    <div className="col-12">
                        <img style={{height: '100%', objectFit: 'cover'}} className={'about-box2'} src={imgPath}
                             alt="aboutthumb"/>
                    </div>
                    <div className="col-12">
                        <div className="">
                            <SecSubTitle><i className="fas fa-bring-forward"/>{subTitle}</SecSubTitle>
                            <SecTitle className="text-capitalize">{title}</SecTitle>
                            <p>{description}</p>
                            <List className="list-style11">
                                {bottomList.map(o => <List.Item><i className="far fa-check-circle"/> {o}</List.Item>)}
                            </List>
                        </div>
                    </div>

                </div>
            {/*</div>*/}

        </div>
    </div>
);

export default AboutSevenCopy;